/* eslint-disable consistent-return */
import { useRef, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

export const useShallowEqualSelector = selector => useSelector(selector, shallowEqual);

export { useStudentMoodleSync } from './useStudentMoodleSync';

export const useInterval = (callback, delay, rejectCondition) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay != null && !rejectCondition) {
      tick();
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, rejectCondition]);
};
